import template from './subscription.html';
import controller from './subscription.controller';

export default {
    template,
    controller
};
